import { render, staticRenderFns } from "./myClassCourseDialog.vue?vue&type=template&id=447f5d32&scoped=true"
import script from "./myClassCourseDialog.vue?vue&type=script&lang=js"
export * from "./myClassCourseDialog.vue?vue&type=script&lang=js"
import style0 from "./myClassCourseDialog.vue?vue&type=style&index=0&id=447f5d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f5d32",
  null
  
)

export default component.exports